import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { GlobeAltIcon, LightningBoltIcon, DocumentIcon } from '@heroicons/react/outline';
import { Icon } from '@project/shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var features = [{
  name: 'Instant updates',
  description: 'All your important links in one place, synchronized instantly.',
  icon: LightningBoltIcon
}, {
  name: 'One single YAML file',
  description: 'Connect tab.run to your github repository and create a single YAML file with all your links.',
  icon: DocumentIcon
}, {
  name: 'Get the chrome extension',
  description: 'Replace your chrome home page with our single page and move even faster.',
  icon: GlobeAltIcon
}];
export default function Home() {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: "Home | Tab.run"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "relative bg-gray-50 pt-16 overflow-hidden sm:pt-24 lg:pt-32",
      children: /*#__PURE__*/_jsxs("div", {
        className: "mx-auto max-w-md px-4 text-center sm:px-6 sm:max-w-3xl lg:px-8 lg:max-w-7xl",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("div", {
            className: "text-center flex items-center justify-center",
            children: /*#__PURE__*/_jsx(Icon, {})
          }), /*#__PURE__*/_jsx("p", {
            className: "mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl",
            children: "Say goodbye to your bookmarks."
          }), /*#__PURE__*/_jsx("p", {
            className: "mt-5 max-w-prose mx-auto text-xl text-gray-500",
            children: "Create one single page with all the links your team needs. No need to synchronize your bookmarks anymore. Join our waiting list to be the first to know when we launch."
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "relative bg-gray-50 pt-8 sm:pt-16 lg:pt-24",
          children: /*#__PURE__*/_jsx("div", {
            className: "mx-auto max-w-md px-4 text-center sm:px-6 sm:max-w-3xl lg:px-8 lg:max-w-7xl",
            children: /*#__PURE__*/_jsx("div", {
              className: " -mb-10 sm:-mb-24 lg:-mb-80",
              children: /*#__PURE__*/_jsx("div", {
                className: "rounded-lg shadow-xl ring-1 ring-black ring-opacity-5",
                children: /*#__PURE__*/_jsx(Image, {
                  className: "rounded-lg shadow-xl ring-1 ring-black ring-opacity-5",
                  src: "/screenshot_chrome.png",
                  alt: "",
                  width: "1280",
                  height: "811",
                  unoptimized: true
                })
              })
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "relative bg-white py-16 sm:py-24 lg:py-32",
      children: /*#__PURE__*/_jsxs("div", {
        className: "mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl",
        children: [/*#__PURE__*/_jsx("p", {
          className: "mt-5 max-w-prose mx-auto text-xl text-gray-500",
          children: "Forget about bookmarks or sharing links to your tools in Slack. Just update your file and we take care of the rest."
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-12",
          children: /*#__PURE__*/_jsx("div", {
            className: "grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3",
            children: features.map(function (feature) {
              return /*#__PURE__*/_jsx("div", {
                className: "pt-6",
                children: /*#__PURE__*/_jsx("div", {
                  className: "flow-root bg-gray-50 rounded-lg px-6 pb-8",
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "-mt-6",
                    children: [/*#__PURE__*/_jsx("div", {
                      children: /*#__PURE__*/_jsx("span", {
                        className: "inline-flex items-center justify-center p-3 bg-indigo-500 rounded-md shadow-lg",
                        children: /*#__PURE__*/_jsx(feature.icon, {
                          className: "h-6 w-6 text-white",
                          "aria-hidden": "true"
                        })
                      })
                    }), /*#__PURE__*/_jsx("h3", {
                      className: "mt-8 text-lg font-medium text-gray-900 tracking-tight",
                      children: feature.name
                    }), /*#__PURE__*/_jsx("p", {
                      className: "mt-5 text-base text-gray-500",
                      children: feature.description
                    })]
                  })
                })
              }, feature.name);
            })
          })
        })]
      })
    })]
  });
}